export default {
    crop: {
        title: "Cosecha",
        cropSize: "Tamaño del cultivo",
        zoom: "Zoom",
        custom: 'Personalizado',
        post: 'Publicación',
        square: 'Cuadrado',
        landscape: 'Paisaje',
        story: 'Historia',
        portrait: 'Retrato',
        carousel: 'Carrousel',
        commonAspectRatio: 'Proporción de aspecto común',
    },
};
